import styledComp from 'styled-components';
import { Error, FiberManualRecord as FiberManualRecordIcon } from '@mui/icons-material';
import {
  Table, FormGroup, TableRow,
  Tabs,
  Tab,
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { statusToColorMap } from './statusToColorMap';
import { ActionStatus } from '../../../api/vault/assetStatus/interfaces';
import { Styling, Colors } from '../../../constants';
import Button from '../VaultButton';

export const ClearCompletedAssetsButton = styledComp(Button)`
  border-radius: 10px;
  border-width: 2px;

  &:hover:enabled, &:focus:enabled {
    background-color: ${Colors.PAPER_DARKER_1};
  }

  &:active:enabled {
    background-color: ${Colors.PAPER};
  }
`;

export const DeleteQueuedAssetsButton = styledComp(Button)`
  border-radius: 10px;
  margin-left: 10px;
`;

export const ButtonsContainer = styledComp.div`
  display: flex;
`;

export const Actions = styledComp.div`
  align-items: center;
  padding: ${Styling.DEFAULT_SPACING}px;
  margin-top: -${Styling.DEFAULT_SPACING_HALVED}px;
  display: flex;
  justify-content: space-between;

  .MuiFormControlLabel-label, button {
    font-size: 14px;
  }
`;

export const DatePickerStyled = styledComp(DatePicker)`
  .MuiInputBase-root {
    height: 43px;
  }
`;

export const FilterContainer = styledComp.div`
  display: flex;
  justify-content: space-between;
`;

export const StatusFilterContainer = styledComp(FormGroup)`
  width: 180px;
  .MuiSelect-select.MuiInputBase-input {
    padding: 10px 12px;
  }
  margin-right: ${Styling.DEFAULT_SPACING}px;
`;

export const StatusContainer = styledComp.div`
  align-items: center;
  display: flex;
  margin: 0 auto;
`;

interface IStatusIconProps {
  status: ActionStatus;
}
export const StatusIcon = styledComp(FiberManualRecordIcon) <IStatusIconProps>`
  color: ${(props) => (statusToColorMap.get(props.status))};
  margin-right: ${Styling.DEFAULT_SPACING_HALVED}px;
`;

export const ProgressContainer = styledComp.div`
  height: 4px;
`;

export const StyledTableContainer = styledComp.div`
  height: 100%;
  overflow-y: auto;
`;

export const StyledTable = styledComp(Table)`
  table-layout: fixed;
  th, td {
    padding: 10px;
  }
  th {
    padding-top: 16px;
    padding-bottom: 16px;
  }
  td.actionButtons {
    @media only screen and (min-width: 900px) {
      width: 120px;
    }
  }
`;

export const RefreshLabel = styledComp.span`
  overflow: hidden;
  margin-left: auto;
  margin-right: 3rem;
  font-size: ${Styling.HEADER_FONT_SIZE}px;
`;

const tabBorderColor = 'rgba(140, 140, 140, .5)';
export const StyledTabs = styledComp(Tabs)`
  border-bottom: 1px solid ${tabBorderColor};
  height: 60px;
  min-height: 60px;
  .MuiTabs-flexContainer {
    justify-content: left;
    height: 100%;
    align-items: end;
    padding-left: 10px;
  }
  .MuiTabs-indicator {
    top: 0;
    overflow: hidden;
    border-radius: 5px 5px 0px 0px;
    background-color: transparent;
    height: 100%;
    &::after {
      content: "";
      height: 5px;
      width: 100%;
      top: 0;
      position: absolute;
      background-color: rgb(218, 23, 23);
    }
  }
`;

export const StyledTab = styledComp(Tab)`
  height: calc(100% - 5px);
  min-height: 50px;
  flex-grow: 0;
  min-width: 140px;
  background-color: rgba(140, 140, 140, .1);
  color: black;
  border: 1px solid ${tabBorderColor};
  border-right: none;
  border-bottom: none;
  &.first {
    border-radius: 5px 0px 0px 0px;
  }
  &.last {
    border-radius: 0px 5px 0px 0px;
    border-right: 1px solid ${tabBorderColor};
  }
  &.Mui-selected {
    background-color: transparent;
    border-radius: 0;
  };
  
`;

export const TabLabelContainer = styledComp.div`
  display: flex;
  align-items: center;
  .label {
    margin-left: 8px;
    margin-right: 8px;
  }
  .MuiBadge-root {
  }
`;

export const StyledError = styledComp(Error)`
  fill: rgb(218, 23, 23);
  display: none;
  &.active {
    display: block;
  }
`;
